import { z } from "zod/v4";

import { OfferWithIdSchema } from "../../../../dtos/offers";

export const PluginOfferSchema_2024_05_05 = OfferWithIdSchema;

export type PluginOfferType_2024_05_05 = z.infer<
  typeof PluginOfferSchema_2024_05_05
>;
